// extracted by mini-css-extract-plugin
export default {"contact":"ContactPage_contact__x9b7Z"};